import { Box, Grid } from "@mui/material";
import {
    RecordContext,
    SimpleForm,
    useStore
} from "react-admin";
import { useAccount, useOrder, useWebsite } from "../../hooks";
import { CartForm } from "./form";

export const CartEdit = (): JSX.Element => {
    const [orderId] = useStore<number>("orderId");
    const w = useWebsite();
    const { id: buyerId } = useAccount();
    const order = useOrder({ buyerId, sellerId: w.accountId, orderId });
    const sx = { flexGrow: 1, width: "100%" };
    return (
        <RecordContext.Provider value={order}>
            <SimpleForm component={({ children }) => <Box sx={{ ...sx, py: 0.5 }}>{children}</Box>} toolbar={<div />} sx={{ display: "flex" }}>
                <Grid container sx={sx}>
                    <CartForm />
                </Grid>
            </SimpleForm>
        </RecordContext.Provider>
    );
};

export default CartEdit;
